import { BaseContentSection } from '@jbhi-fi/apis/src/orderTrackingThemeApi/types';
import React from 'react';
import { MarkdownBlock } from '../../MarkdownBlock';
import { styles } from './ImportantTextBlock.css';

export const ImportantTextBlock = ({ heading, content }: BaseContentSection) => {
  return (
    <div role="paragraph" className={styles.importantText}>
      {heading ? <div>{heading}</div> : null}
      {content ? (
        <div role="paragraph">
          <MarkdownBlock shouldLinkOpenInNewTab>{content}</MarkdownBlock>
        </div>
      ) : null}
    </div>
  );
};
